/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefMarkdownData } from '../../models/api-def-markdown-data';
import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsDeleteMarkdownVersion$Params {

/**
 * The ID of the organization to delete the markdown version from
 */
  organizationId: string;

/**
 * The ID of the project to delete the markdown version from
 */
  projectId: string;

/**
 * The ID of the upload intent to delete the markdown version for
 */
  uploadIntentId: string;
}

export function organizationsDeleteMarkdownVersion(http: HttpClient, rootUrl: string, params: OrganizationsDeleteMarkdownVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsDeleteMarkdownVersion.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.path('uploadIntentId', params.uploadIntentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      'markdown'?: ApiDefMarkdownData;
      }>;
    })
  );
}

organizationsDeleteMarkdownVersion.PATH = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';
